import CompLayout from "@/pcomponents/comp/layout/layout";
import RequestListArea from "@/pages/comp/plan/video/acommon/request/list";

function ListPage() {

  return (
    <CompLayout>
      <RequestListArea></RequestListArea>
    </CompLayout>
  );
}

export default ListPage;